import { spell_full } from '@Api';
import { MagicSpell, SpellLvl } from '@Models';
import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { SpellDurationMapper } from '@Mapper/ninthAge/spell-duration.mapper';
import { SpellTypeMapper } from '@Mapper/ninthAge/spell-type.mapper';

@injectable()
export class MagicSpellMapper {
  @inject(TYPES.Mapper.SpellDurationMapper)
  private _spellDurationMapper!: SpellDurationMapper;
  @inject(TYPES.Mapper.SpellTypeMapper)
  private _spellTypeMapper!: SpellTypeMapper;

  map(item: spell_full): MagicSpell {
    return {
      id: item.id,
      name: item.name ?? '',
      castingValue: item.casting_value,
      range: item.range,
      effect: item.effect,
      typeLvl: this.mapTypeLvl(item.type_lvl),
      types:
        item.spell_types?.map((type) => this._spellTypeMapper.map(type)) ?? [],
      duration: this._spellDurationMapper.map(item.spell_duration),
    } satisfies MagicSpell as MagicSpell;
  }

  mapTypeLvl(item: spell_full.type_lvl): SpellLvl {
    switch (item) {
      case spell_full.type_lvl.ONE:
        return SpellLvl.ONE;
      case spell_full.type_lvl.TWO:
        return SpellLvl.TWO;
      case spell_full.type_lvl.THREE:
        return SpellLvl.THREE;
      case spell_full.type_lvl.FOUR:
        return SpellLvl.FOUR;
      case spell_full.type_lvl.FIVE:
        return SpellLvl.FIVE;
      case spell_full.type_lvl.SIX:
        return SpellLvl.SIX;
      case spell_full.type_lvl.A:
        return SpellLvl.A;
      case spell_full.type_lvl.T:
        return SpellLvl.T;
    }

    return SpellLvl.ZERO;
  }
}
